import { Injectable, inject } from '@angular/core';
import {
  IQueryParam,
  IListado,
  ITracker,
  ICreateTracker,
  IUpdateTracker,
  IDeviceChirpstack,
} from 'modelos/src';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { HttpClientService } from '../../../../auxiliares/servicios/http.service';

@Injectable({
  providedIn: 'root',
})
export class TrackersService {
  private http = inject(HttpClientService);

  public getFiltered(queryParams?: IQueryParam): Promise<IListado<ITracker>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`/trackers`, { params });
  }

  public getById(id: string): Promise<ITracker> {
    return this.http.get(`/trackers/${id}`);
  }

  /**
   * @param crearServer solo aplica a T1000-B. `false` da de alta el tracker en
   *   IRIX sin tocar el Network Server (para equipos que ya existen allá).
   */
  public create(
    dato: ICreateTracker,
    crearServer = true,
  ): Promise<ITracker> {
    return this.http.post(`/trackers?crearServer=${crearServer}`, dato);
  }

  /** Crea el device SOLO en el Network Server, para un tracker ya existente. */
  public createChirpstack(dato: ITracker): Promise<void> {
    return this.http.post(`/trackers/createChirpstack`, dato);
  }

  public update(id: string, dato: IUpdateTracker): Promise<ITracker> {
    return this.http.put(`/trackers/${id}`, dato);
  }

  /**
   * Device del tracker T1000-B tal como está en el Network Server. Diagnóstico:
   * confirma que el provisioning en ChirpStack quedó bien. Solo aplica a
   * T1000-B (el resto de los trackers no son LoRaWAN).
   */
  public consultarChirpstack(id: string): Promise<IDeviceChirpstack> {
    return this.http.get(`/trackers/consultarChirpstack/${id}`);
  }

  public enviarComando(id: string, comando: string) {
    return this.http.post(`/trackers/enviarcomando`, { id, comando });
  }

  /**
   * @param eliminarServer solo aplica a T1000-B. `false` borra el tracker en
   *   IRIX y deja el device vivo en el Network Server.
   */
  public delete(id: string, eliminarServer = true): Promise<void> {
    return this.http.delete(
      `/trackers/${id}?eliminarServer=${eliminarServer}`,
    );
  }

  /** Borra el device SOLO en el Network Server; el tracker queda en IRIX. */
  public deleteChirpstack(id: string): Promise<void> {
    return this.http.delete(`/trackers/deleteChirpstack/${id}`);
  }
}
